import React from 'react';
import { Button, Col, Drawer, Row, Table, Tag } from 'antd';
import { useState, useEffect } from 'react';
import PageTitle from 'shared_components/page_title';
import DownloadCSV from 'shared_components/download_csv';
import { fetchCheckInLocationItems, applySorting } from 'services/settings/lookup_table/checkinLocation.jsx';
import CheckInLocationForm from './checkInLocationForm.jsx';
import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import update from 'immutability-helper';
import DragableBodyRow from 'shared_components/drag_and_drop_row';
import { showMessage } from 'services/settings/message';

function CheckInLocation() {
	const [checkInLocation, setCheckInLocation] = useState([]);
	const [hasReordered, setHasReordered] = useState(false);
	const [drawerState, setDrawerState] = useState({
		visible: false,
		drawerTitle: '',
		selecetedData: null,
		buttonNames: '',
	});

	const getCheckInLocation = async () => {
		const data = await fetchCheckInLocationItems();
		// Sort by locationSort ASC, but put records without locationSort at the end
		const sortedData = (data || []).sort((a, b) => {
			if (a.locationSort != null && b.locationSort != null) {
				return a.locationSort - b.locationSort;
			}
			if (a.locationSort == null) return 1;
			if (b.locationSort == null) return -1;
			return 0;
		});
		setCheckInLocation(sortedData);
	};

	useEffect(() => {
		getCheckInLocation();
	}, []);

	const onSuccessCreate = async () => {
		onDrawerClose();
		await getCheckInLocation();
		showMessage('M0002');
	};

	const onSuccessUpdate = async () => {
		onDrawerClose();
		await getCheckInLocation();
		showMessage('M0003');
	};

	const applySort = async () => {
		const dataPayload = checkInLocation.map((rec, index) => {
			return {
				locationID: rec.locationID,
				locationSort: index + 1,
			};
		});

		await applySorting(dataPayload);
		setHasReordered(false);
	};

	const moveRow = (dragIndex, hoverIndex) => {
		const dragRow = checkInLocation[dragIndex];

		const updatedData = update({ checkInLocation }, {
			checkInLocation: { $splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]] }
		});

		setCheckInLocation(updatedData.checkInLocation);
		setHasReordered(true);
	};

	const showDrawer = record => {
		setDrawerState({
			visible: true,
			drawerTitle: 'ADD LOCATION',
			selecetedData: null,
			buttonNames: 'ADD',
		});
	};

	const displayDrawer = record => {
		setDrawerState({
			visible: true,
			drawerTitle: 'UPDATE LOCATION',
			selecetedData: record,
			buttonNames: 'UPDATE',
		});
	};

	const onDrawerClose = () => {
		setDrawerState({
			visible: false,
			drawerTitle: '',
			selecetedData: null,
			buttonNames: '',
		});
	};

	const components = {
		body: {
			row: DragableBodyRow,
		},
	};

	const columns = [
		{
			title: 'LOCATION NAME',
			dataIndex: 'locationName',
			width: 300,
			sorter: (a, b) => { return a.locationName.localeCompare(b.locationName) },
			sortDirections: ['ascend', 'descend'],
		},
		{
			title: 'DATE CREATED',
			dataIndex: 'createdDate',
			width: 200,
			render: date => date ? new Date(date).toLocaleDateString() : '',
		},
		{
			title: 'STATUS',
			dataIndex: 'isActive',
			width: 100,
			render: active => (
				<Tag color={active === 0 ? 'red' : 'green'}>{active === 0 ? 'INACTIVE' : 'ACTIVE'}</Tag>
			),
		},
	];

	return (
		<>
			<Row justify="end" style={{ marginTop: 12, marginBottom: 12, display: 'flex', gap: '10px' }}>
				<DownloadCSV
					confirmRequired={true}
					isLookupTable={true}
					confirmDetails={{
						section: 'CHECK-IN LOCATIONS',
						count: checkInLocation.length
					}}
					data={checkInLocation}
					filename="check-in_locations"
					columns={[
						{ title: 'LOCATION NAME', dataIndex: 'locationName' },
						{ 
							title: 'DATE CREATED', 
							dataIndex: 'createdDate',
							render: date => date ? new Date(date).toLocaleDateString() : ''
						},
						{ 
							title: 'STATUS', 
							dataIndex: 'isActive',
							render: active => active === 0 ? 'INACTIVE' : 'ACTIVE'
						}
					]}
				/>
				<Button onClick={applySort} shape="round" type="primary" disabled={!hasReordered}>
					APPLY SORTING
				</Button>
				<Button
					// disabled={buttonDisable}
					type="primary"
					shape="round"
					onClick={showDrawer}
					style={{ marginRight: '15px' }}
					// icon={<PlusOutlined />}
				>
					ADD LOCATIONS
				</Button>
				{/* <LocationPager handleChange={this.handleChange} /> */}
			</Row>
			<DndProvider backend={HTML5Backend}>
				<Table
					dataSource={checkInLocation}
					columns={columns}
					components={components}
					pagination={false}
					rowKey={record => record.locationID}
					onRow={(record, index) => ({
						index: checkInLocation.findIndex(item => item.locationID === record.locationID),
						moveRow: moveRow,
						onDoubleClick: () => {
							displayDrawer(record);
						},
					})}
				/>
			</DndProvider>
			<Drawer
				title={drawerState.drawerTitle}
				width="30%"
				visible={drawerState.visible}
				onClose={onDrawerClose}
				destroyOnClose
			>
				<CheckInLocationForm
					buttonNames={drawerState.buttonNames}
					onDrawerClose={onDrawerClose}
					selecetedData={drawerState.selecetedData}
					onSuccessCreate={onSuccessCreate}
					onSuccessUpdate={onSuccessUpdate}
				/>
			</Drawer>
		</>
	);
}

export default CheckInLocation;
